import { render, staticRenderFns } from "./DashboardView.vue?vue&type=template&id=fa485540&scoped=true&"
import script from "./DashboardView.vue?vue&type=script&lang=js&"
export * from "./DashboardView.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=fa485540&scoped=true&lang=css&"
import style1 from "@/assets/styles/beneficiary.css?vue&type=style&index=1&id=fa485540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa485540",
  null
  
)

export default component.exports